import { Injectable } from '@angular/core';
import { Toast } from './toast.interface';
import { ToastType } from './toast.type';
import { Observable, BehaviorSubject } from 'rxjs';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ToasterService {
  subject: BehaviorSubject<Toast>;
  toast$: Observable<Toast>;
  DEFAULT_DELAY: number = 4500;

  constructor() {
    let toast : Toast = {
        title: '',
        body: '',
        delay: 0
    }
    this.subject = new BehaviorSubject<Toast>(toast);
    this.toast$ = this.subject.asObservable()
      .pipe(filter(toast => toast !== null));
  }

  show(type: ToastType, title: string, body: string) {
    this.subject.next({type, title, body, delay: this.DEFAULT_DELAY});
  }
}
